import { Check } from "lucide-react";

import { cn } from "@/lib/utils";

interface InfoHubStepNavigationProps {
  steps: string[];
  activeStep: number;
  label?: string;
  onSelect: (step: number) => void;
}

// Side navigation for the agro-advisory wizard. Mirrors the visual language of
// the migrated TraderRegistrationStepNavigation while keeping the legacy
// free-navigation behavior (any step can be selected directly).
export const InfoHubStepNavigation = ({
  steps,
  activeStep,
  label,
  onSelect,
}: InfoHubStepNavigationProps) => (
  <nav aria-label={label} className="mt-8">
    <ol>
      {steps.map((stepLabel, index) => {
        const isActive = activeStep === index;
        const isComplete = activeStep > index;
        const isLastStep = index === steps.length - 1;

        return (
          <li key={stepLabel} className="relative pb-10 last:pb-0">
            {!isLastStep && (
              <span
                aria-hidden="true"
                className={cn(
                  "absolute bottom-0 left-4.5 top-9 w-px transition-colors",
                  isComplete ? "bg-primary" : "bg-border"
                )}
              />
            )}
            <button
              type="button"
              aria-current={isActive ? "step" : undefined}
              onClick={() => onSelect(index)}
              className="relative z-10 flex w-full items-center gap-3 bg-transparent text-left text-sm transition-colors hover:text-primary"
            >
              <span
                aria-hidden="true"
                className={cn(
                  "flex size-9 shrink-0 items-center justify-center rounded-full border border-primary text-sm font-semibold transition-colors",
                  isComplete || isActive
                    ? "bg-primary text-primary-foreground"
                    : "bg-background text-primary"
                )}
              >
                {isComplete ? <Check className="size-4" /> : index + 1}
              </span>
              <span
                className={cn(
                  "font-medium",
                  isActive ? "text-foreground" : "text-muted-foreground"
                )}
              >
                {stepLabel}
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  </nav>
);
